import { createRoute, Outlet } from "@tanstack/react-router";
import { accountDashboardLayoutRoute, accountRoutes } from "../../../App";
import { memo } from "react";
import { z } from "zod";
import { MapSources } from "./Sources";
import { AIMap } from "./AIMap";
import { MapLayers } from "./Layers";
import { MapSettings } from "./Settings";
import { MapDashboardLayout } from "../../../layouts/MapDashboardLayout";
import { NewMap } from "./NewMap";
import { Maps } from "./Maps";
import { MapVersions } from "./Versions";
import { MapMarkers } from "./Markers";

export const mapDashboardLayoutRoute = createRoute({
  getParentRoute: () => accountRoutes,
  path: "/maps/$map",
  validateSearch: z.object({
    editor: z.enum(["text", "style"]).optional(),
    chatId: z.number().optional(),
  }),
  component: memo(() => {
    return (
      <MapDashboardLayout>
        <Outlet />
      </MapDashboardLayout>
    );
  }),
});

const mapSettingsRoute = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/settings",
  component: MapSettings,
});

const mapLayersRoute = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/layers",
  component: MapLayers,
});

const mapMarkersRoute = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/markers",
  component: MapMarkers,
});

const mapSourcesRoute = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/sources",
  component: MapSources,
});

const mapVersionsRoute = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/versions",
  component: MapVersions,
});

const mapAIAssistant = createRoute({
  getParentRoute: () => mapDashboardLayoutRoute,
  path: "/ai",
  component: AIMap,
});

export const accountNewMapRoute = createRoute({
  getParentRoute: () => accountDashboardLayoutRoute,
  path: "/new-map",
  component: NewMap,
});

export const accountMapsListRoute = createRoute({
  getParentRoute: () => accountDashboardLayoutRoute,
  path: "/maps",
  component: Maps,
});

export const accountMapRoutes = mapDashboardLayoutRoute.addChildren([
  mapSettingsRoute,
  mapLayersRoute,
  mapSourcesRoute,
  mapVersionsRoute,
  mapMarkersRoute,
  mapAIAssistant,
]);
